import { Breadcrumbs } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { globalStyles as styles } from '../core/style/gstheme';
import { processHashLocation } from '../core/utils/utils';
import Crumb from './Crumb';

class BreadcrumbGenerator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bc: []
        };
    }

    static getDerivedStateFromProps(props) {
        const paramsMap = processHashLocation(props.location);
        const newBCstate = [];
        props.breadcrumb.path && props.breadcrumb.path.forEach(part => {
            if (paramsMap.has(part)) {
                newBCstate.push({
                    name: part,
                    value: paramsMap.get(part)
                });
            }
        });
        return {
            bc: newBCstate
        };
    }

    render() {

        const { bc } = this.state;
        const { classes, breadcrumb, graph } = this.props;

        return (
            <Breadcrumbs className={classes.breadcrumb} separator={<NavigateNextIcon style={{ color: '#616161', fontSize: '14px' }} />}>
                <span data-test="start-crumb" className={classes.crumb}>
                    <Link component={RouterLink} className={classes.linkText} to="/">Start</Link>
                </span>
                <span data-test="app-crumb" className={classes.crumb}>
                    <Link component={RouterLink} className={classes.linkText} to={breadcrumb.baseURL}>{breadcrumb.title}</Link>
                </span>
                {graph && bc.map((item, index) => {
                    const urlPart = breadcrumb.url[item.name];
                    let hashPart = [];
                    for (let i = 0; i <= index; i++) {
                        hashPart.push(bc[i].name + "=" + bc[i].value);
                    }
                    return <Crumb
                        dataTest={"crumb-" + index}
                        id={item.value}
                        graph={graph}
                        key={item.value}
                        url={urlPart + "#" + hashPart.join('&')} />;
                })}
                <span data-test="static-crumb" className={classes.crumb}>
                    {breadcrumb.static !== undefined ? breadcrumb.static : null}
                </span>
            </Breadcrumbs>
        );
    }
}

BreadcrumbGenerator.propTypes = {
    breadcrumb: PropTypes.object.isRequired,
    location: PropTypes.object,
    graph: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(BreadcrumbGenerator));